const investigationTypes=
{blood:[
   "FBC",
   "Coagulation Screen",
   "INR",
    "ESR",
    "U&E",
    "LFT",
    "Bone profile",
    "Fasting Glucose",
    "Random Glucose",
    "Amylase",
    "Fasting Lipids",
    "Random Lipids",
    "CRP",
    "Thyroid function",
    "Globulins",
    "HBA1c",
    "B12",
    "Ferritin",
    "Iron Studies",
    "B12",
    "Folate",
    "Vit D",
    "Plasma Protein electrophoresis",
    "Glandular Fever Screen",
    "Hb-opath Screen",
    "Coeliac screen",
    "ACR",
    "Ca125",
    "PSA",
    "Ca19-9", 
    "Plasma viscosity"
    ],

urine:[ 
    "Urine Dipstick and culture",
    "Urine Bence-Jones protein"
    ],

stool:[
    "FIT tests",
    "Calprotectin",
    "Elastase",
    "Stool culture"
    ],

imaging:[
    "Bone XR",
    "Bone XR (urgent)",
    "Chest X Ray",
    "CT Abdomen",
    "CT Chest",
    "MRI brain",
    "CT brain (if MRI contraindicated)",
    "Abdominal Ultrasound",
    "Pelvic Ultrasound",
    "Soft Tissue Ultrasound",
    "Soft Tissue Ultrasound (urgent)",
    "Testicular ultrasound"
    ],

endoscopy:[
    "Urgent Upper GI Endoscopy",
    "Routine Upper GI Endoscopy"

    ],

}
export default investigationTypes